// import React from "react";
// import styles from "../Category.module.css";

// export default function ViewCategoryModal({ category, onClose }) {
//   if (!category) return null;
//   return (
//     <div className={styles.modalBackdrop}>
//       <div className={styles.modal}>
//         <h3>Category Details</h3>
//         <div className={styles.detailGrid}>
//           <div>
//             <span>Name</span>
//             <strong>{category.categoryName}</strong>
//           </div>
//           <div>
//             <span>Slug</span>
//             <code>{category.category_slug}</code>
//           </div>
//           <div>
//             <span>Parent</span>
//             <strong>{category.parentName || "—"}</strong>
//           </div>
//           <div>
//             <span>Products</span>
//             <strong>{category.count ?? 0}</strong>
//           </div>
//         </div>
//         {category.description && (
//           <p className={styles.descriptionBlock}>{category.description}</p>
//         )}
//         <div className={styles.modalActions}>
//           <button type="button" className={styles.btnPrimary} onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import styles from "./ViewCategoryModal.module.css";
import RenderToast from "../../../components/RenderToast";
import { AiOutlineCopy } from "react-icons/ai";
import { FaBox } from "react-icons/fa";
import { RiParentLine } from "react-icons/ri";

export default function ViewCategoryModal({ category, onClose }) {
  if (!category) return null;

  const handleCopySlug = () => {
    navigator.clipboard.writeText(category.category_slug);
    RenderToast({ type: "success", message: "Slug copied!" });
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className={styles.header}>
          <h3>Category Overview</h3>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        {/* SCROLLABLE CONTENT */}
        <div className={styles.content}>
          {/* INFO BLOCKS */}
          <div className={styles.infoContainer}>
            <div className={styles.infoCard}>
              <div className={styles.iconCircle}>
                <FaBox />
              </div>
              <div>
                <span className={styles.label}>Category Name</span>
                <p className={styles.value}>{category.categoryName}</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconCircle}>
                <AiOutlineCopy />
              </div>
              <div>
                <span className={styles.label}>Slug</span>
                <div className={styles.slugRow}>
                  <code className={styles.code}>{category.category_slug}</code>
                  <button className={styles.copyBtn} onClick={handleCopySlug}>
                    Copy
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconCircle}>
                <RiParentLine />
              </div>
              <div>
                <span className={styles.label}>Parent</span>
                <p className={styles.value}>{category.parentName || "—"}</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconCircle}>
                <FaBox />
              </div>
              <div>
                <span className={styles.label}>Products</span>
                <p className={styles.value}>{category.count ?? 0}</p>
              </div>
            </div>
          </div>

          {/* DESCRIPTION */}
          {category.description && (
            <div className={styles.descriptionBox}>{category.description}</div>
          )}
        </div>

        {/* FOOTER */}
        <div className={styles.actions}>
          <button className={styles.btnClose} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
